import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "toolbar" }

import TopBar from "@/components/topbar/TopBar.vue";
import SideBar from "@/components/SideBar.vue";
import ToolBar from "@/components/toolbar/ToolBar.vue";
import ReportPage from "@/components/report/ReportPage.vue";
import { useAuthenticationStore, LogStatus } from "@/stores/authentication";
import { useEmbedStore } from "@/stores/embedStore";
import { onMounted, ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const state = ref({
  status: 0, // 0 - loading, 1 - logged in, -1 - not logged in
  link: "",
  name: "",
});

onMounted(async () => {
  const Authorization = useAuthenticationStore();
  loggedCheck(Authorization.getLoggedStatus());
  state.value.status = 0;
  await Authorization.login();
  if (Authorization.getLoggedStatus() == LogStatus.Logged) {
    state.value.status = 1;
    loggedCheck(Authorization.getLoggedStatus());
  } else {
    state.value.status = -1;
  }

  const embedStore = useEmbedStore();
  // get parameters from url and load report data
  const urlParams = new URLSearchParams(window.location.search);
  const url = urlParams.get("url") ?? "";
  await embedStore.loadReportData(url);
  state.value.link = embedStore.getReportLink();
  state.value.name = embedStore.getReportName();
});

function loggedCheck(value: LogStatus) {
  if (value == LogStatus.Logged) {
    sessionStorage.getItem("log_to") ?? "/";
    sessionStorage.removeItem("log_to");
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TopBar),
    (state.value.status == 1)
      ? (_openBlock(), _createBlock(SideBar, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(ToolBar, {
        reportName: state.value.name
      }, null, 8, ["reportName"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(ReportPage, {
        link: state.value.link,
        name: state.value.name
      }, null, 8, ["link", "name"])
    ])
  ], 64))
}
}

})